package com.klantenstop.web.pages.admin.companies

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import com.klantenstop.web.components.layout.AdminPageLayout
import com.materialkobweb.utils.rememberViewModel
import com.materialkobweb.utils.Logger
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import kotlinx.coroutines.flow.collectLatest
import org.jetbrains.compose.web.css.px

@Page("/admin/bedrijven")
@Composable
fun CompaniesPage() {
    // Use constant key to maintain ViewModel across navigation
    val viewModel = rememberViewModel { CompaniesViewModel() }
    val state by viewModel.state.collectAsState()

    LaunchedEffect(Unit) {
        viewModel.effect.collectLatest { effect ->
            when (effect) {
                is CompaniesContract.Effect.NavigateToCreate -> {
                    // TODO: Navigate to create page
                    Logger.debug("CompaniesPage", "Navigate to create company")
                }

                is CompaniesContract.Effect.NavigateToEdit -> {
                    // TODO: Navigate to edit page with companyId
                    Logger.debug("CompaniesPage", "Navigate to edit company: ${effect.companyId}")
                }

                is CompaniesContract.Effect.ShowError -> {
                    // TODO: Show error snackbar/toast
                    Logger.error("CompaniesPage", effect.message)
                }

                is CompaniesContract.Effect.ShowSuccess -> {
                    // TODO: Show success snackbar/toast
                    Logger.info("CompaniesPage", effect.message)
                }
            }
        }
    }

    AdminPageLayout(
        title = "Companies",
        fabOnClick = {
            viewModel.emitEffect(CompaniesContract.Effect.NavigateToCreate)
        }
    ) {
        CompaniesContent(state = state, sendIntent = viewModel::sendIntent)
    }
}

@Composable
fun CompaniesContent(
    state: CompaniesContract.State,
    sendIntent: (CompaniesContract.Intent) -> Unit
) {
    val colorMode = ColorMode.current

    Column(
        modifier = Modifier
            .fillMaxSize()
            .padding(40.px),
        verticalArrangement = Arrangement.spacedBy(20.px),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        SpanText(
            text = "Companies Management",
            modifier = Modifier
                .fontSize(32.px)
                .fontWeight(FontWeight.Bold)
                .color(if (colorMode.isLight) Colors.Black else Colors.White)
        )

        SpanText(
            text = "Manage registered companies here",
            modifier = Modifier
                .fontSize(18.px)
                .fontWeight(FontWeight.Normal)
                .color(if (colorMode.isLight) Colors.Gray else Colors.LightGray)
        )

        if (state.isLoading) {
            SpanText(
                text = "Loading...",
                modifier = Modifier
                    .fontSize(16.px)
                    .color(if (colorMode.isLight) Colors.Gray else Colors.LightGray)
            )
        } else {
            SpanText(
                text = "Companies: ${state.companies.size}",
                modifier = Modifier
                    .fontSize(16.px)
                    .color(if (colorMode.isLight) Colors.Gray else Colors.LightGray)
            )
        }

        // TODO: Add table/list of companies with columns (name, address, status, rating, etc.)
        // TODO: Add search/filter functionality
        // TODO: Add pagination
        // TODO: Add edit/delete/approve actions
        // TODO: Add bulk actions (approve multiple, delete multiple, etc.)
    }
}




